module.exports = __webpack_public_path__ + "static/media/57.155a2aa1.jpg";